<template>
  <!-- マスタデータ管理 -->
  <div id="dataManagement">
    <div id="container">
      <masterMaint :isMaint="false" />
    </div>
  </div>
</template>

<script>
import MasterMaint from '@/components/mock/philips/master/master/MasterMaint'

export default {
  name: "dataManagement",
  methods: {},
  data() {
    return {};
  },
  components: {
    masterMaint: MasterMaint,
  }
};
</script>

<style lang="scss" >
ul.link-area {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
ul.link-area>li {
    margin:10px;
}
a .buttonArea {
    display: flex;
    align-items:center;
    padding: 10px;
    height: 100px;
    border-radius: 5px;
    background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    color:whitesmoke;
}
a .buttonArea:hover{
    color:whitesmoke;
}
a .buttonArea div {
    margin-left:10px;
    padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/nonAdmin/DataManagement.vue